import {
  Autocomplete,
  Stack,
  TextField,
  Typography,
  type AutocompleteChangeReason,
} from '@mui/material'
import type { ApprovalFlow } from '@ulysses-inc/harami_api_client'
import { useId, type FC, type SyntheticEvent } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  toggleEditable,
  updateApprovalFlowId,
} from 'src/state/ducks/templates/editTemplate/actions'
import type { RootState } from 'src/state/store'

const ApprovalFlowRow: FC = () => {
  const dispatch = useDispatch()

  const approvalFlows = useSelector(
    (state: RootState) => state.approvalFlowsState.approvalFlows.approvalFlows,
    shallowEqual,
  )
  const templateApprovalFlowId = useSelector(
    (state: RootState) => state.templatesState.editTemplate.approvalFlowId,
  )

  const selectedValue =
    approvalFlows.find(({ id }) => id === templateApprovalFlowId) ?? null

  const onChange = (
    event: SyntheticEvent,
    value: ApprovalFlow | null,
    reason: AutocompleteChangeReason,
  ) => {
    // テキスト削除（キーボード操作）による選択解除は無視し、クリアボタンのみ許可
    if (value === null && reason === 'clear' && event.type !== 'click') {
      return
    }

    dispatch(updateApprovalFlowId(value?.id ?? 0))

    if (!value) {
      dispatch(toggleEditable(true))
    }
  }

  const labelId = useId()

  return (
    <Stack spacing={1} sx={{ mx: 2 }}>
      <Typography fontWeight="bold" id={labelId}>
        承認フローの設定
      </Typography>
      <Autocomplete
        options={approvalFlows}
        getOptionLabel={({ name }) => name ?? ''}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={selectedValue}
        onChange={onChange}
        renderInput={params => (
          <TextField
            {...params}
            size="small"
            inputProps={{ ...params.inputProps, 'aria-labelledby': labelId }}
          />
        )}
      />
    </Stack>
  )
}

export default ApprovalFlowRow
